export const en = {
    add_participant: 'Add participant',
    cancel: 'Cancel',
    save: 'Save',
};
